import { debounce } from 'lodash';
import { SetStateAction } from 'react';

// For handling search in all tables inputs
export const handleDebouncedSearch = debounce((setState: SetStateAction<any>) => {
  setState();
  console.log('hello');
}, 1000);
